import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HttpClientModule, HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import {NgxDaterangepickerMd} from 'ngx-daterangepicker-material';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';


import {LayoutsModule} from './layouts/layouts.module';
import {PagesModule} from './pages/pages.module';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';

import {ErrorInterceptor} from './core/helpers/error.interceptor';
import {SocialLoginModule, SocialAuthServiceConfig} from 'angularx-social-login';
import {AlertModule, AlertService} from 'ngx-alerts';
import {
  GoogleLoginProvider,
  FacebookLoginProvider
} from 'angularx-social-login';


import {TokenInterceptor} from './core/helpers/token.interceptor';
import {AuthenticationService} from './account/auth/authentication.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CommonService} from './core/services/common.service';
import {AuthGuard} from './core/guards/auth.guard';

// if (environment.defaultauth === 'firebase') {
//   initFirebaseBackend(environment.firebaseConfig);
// } else {
//   // tslint:disable-next-line: no-unused-expression
//   FakeBackendInterceptor;
// }
import {NgxSpinnerModule} from 'ngx-spinner';
import {NgxMaskModule} from 'ngx-mask';
import {RoleGuard} from './core/guards/role.guard';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';

import {AgmCoreModule} from '@agm/core';            // @agm/core
import {AgmDirectionModule} from 'agm-direction';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatNativeDateModule} from '@angular/material/core';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {DatePipe} from '@angular/common';
import {AgmDrawingModule} from '@agm/drawing';
import {MessagingService} from './services/messaging.service';

import {AngularFireModule} from '@angular/fire';
import {AngularFireMessagingModule} from '@angular/fire/messaging';
import {environment} from '../environments/environment';
import {SocketIoModule} from 'ngx-socket-io';
import {SocketIoConfig} from 'ngx-socket-io/src/config/socket-io.config';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

const socketIoConfig: SocketIoConfig = {url: undefined, options: {autoConnect: false, reconnection: false}};

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    PagesModule,
    DragDropModule,
    SocialLoginModule,
    NgxDaterangepickerMd.forRoot(),
    LayoutsModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    MatNativeDateModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxSpinnerModule,
    MatSnackBarModule,
    AgmDrawingModule,
    SocketIoModule.forRoot(socketIoConfig),
    AgmCoreModule.forRoot({ // @agm/core
      apiKey: 'AIzaSyDCCwjzKaunXxklJqtE2r6y-aZrt-WyRYY',
      libraries: ['places', 'drawing', 'geometry'],
    }),
    AgmDirectionModule,
    NgxMaskModule.forRoot(),
    AlertModule.forRoot({maxMessages: 5, timeout: 5000, positionX: 'right', positionY: 'top'}),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    DatePipe,
    // {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    // {provide: HTTP_INTERCEPTORS, useClass: FakeBackendInterceptor, multi: true},
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '481339521717-h09jpmfj6iosa07lpi32jju819t54mcq.apps.googleusercontent.com'
            )
          }
        ]
      } as SocialAuthServiceConfig,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    AuthenticationService,
    CommonService,
    AuthGuard,
    AlertService,
    RoleGuard,
    MessagingService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
